module.exports = __webpack_public_path__ + "static/media/webar.43855b7d.png";